import type { Lead } from "@/domain/models/lead";

export type LeadDto = Lead;

export function mapLeadDto(dto: LeadDto): Lead {
  return {
    id: String(dto.id),
    name: dto.name,
    email: dto.email,
    phone: dto.phone,
    vehicleId: dto.vehicleId ? String(dto.vehicleId) : undefined,
    source: dto.source,
    status: dto.status,
    priority: dto.priority,
    assignedTo: dto.assignedTo,
    message: dto.message,
    createdAt: dto.createdAt,
    updatedAt: dto.updatedAt,
    tags: Array.isArray(dto.tags) ? dto.tags.map(String) : [],
    value: Number(dto.value),
  };
}
